module.exports = __webpack_public_path__ + "packs/media/images/Event_Placeholder-eb8d21cf1b1070abc7cf1dc23607801f.jpg";